import { CascadingFilter } from '@/components/CascadingFilter';
import { countryStateClosedLabel, countryStateGroups } from '@/lib/countryStateCatalog';

export function CountryStateFilter({
  value,
  onChange,
  availableCountryCodes = [],
  countryLabel,
  allCountriesLabel,
  detail,
  ariaLabel,
  className,
  title,
}: {
  value: string;
  onChange: (value: string) => void;
  availableCountryCodes?: readonly string[];
  countryLabel: (code: string) => string;
  allCountriesLabel: string;
  detail?: string;
  ariaLabel: string;
  className?: string;
  title?: string;
}) {
  const groups = countryStateGroups(availableCountryCodes, countryLabel, {
    value: '',
    label: allCountriesLabel,
  });

  return (
    <CascadingFilter
      size="compact"
      label={countryStateClosedLabel(value, groups, allCountriesLabel)}
      {...(detail != null ? { detail } : {})}
      value={value}
      groups={groups}
      onChange={onChange}
      ariaLabel={ariaLabel}
      {...(className ? { className } : {})}
      {...(title ? { title } : {})}
    />
  );
}
